import { styled } from '@linaria/react'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'
import { PopupLayout } from 'vars/popup-layout'
import {
  PopupBottomBlockSC,
  PopupComponentSC,
  PopupGradientOverlay,
  PopupScrollableBlockWithGradient,
  PopupTopBlockSC,
} from '../PopupComponent.styled'

export const MotnStreamingServicesPopupSC = styled.div`
  ${PopupComponentSC} {
    --popup-layout-header-bottom-paddings: var(${FIXED_INDENTS.INDENT_80});
    --popupWidth: 693px;
    --paddingRight: var(${PopupLayout.motnHorizontalPaddings});

    padding-top: var(${FIXED_INDENTS.INDENT_210});
    padding-bottom: var(${FIXED_INDENTS.INDENT_80});

    ${MEDIA.MAX_599} {
      justify-content: center;
    }

    ${MEDIA.MIN_600} {
      --popupWidth: 536px;
      padding-top: var(${FIXED_INDENTS.INDENT_60});
      padding-bottom: var(${FIXED_INDENTS.INDENT_60});
    }

    ${MEDIA.MIN_1024} {
      --popupWidth: 645px;
    }

    ${MEDIA.MIN_1240} {
      padding-top: var(${FIXED_INDENTS.INDENT_120});
      padding-bottom: var(${FIXED_INDENTS.INDENT_100});
    }

    ${MEDIA.MIN_1440} {
      --popupWidth: 693px;
    }

    ${MEDIA.MIN_1640} {
      padding-top: var(${FIXED_INDENTS.INDENT_160});
      padding-bottom: var(${FIXED_INDENTS.INDENT_120});
    }
  }

  ${PopupBottomBlockSC} {
    flex: 0 0 0;
    min-height: 0;
    overflow: hidden;
  }

  ${PopupGradientOverlay} {
    min-height: 0;
    flex: initial;
  }

  ${PopupScrollableBlockWithGradient} {
    display: flex;
    flex-direction: column;
    gap: var(${FIXED_INDENTS.INDENT_20});
    width: 100%;
  }

  ${PopupTopBlockSC} {
    z-index: 1;
  }
`

export const MotnStreamingServicesListSC = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(${FIXED_INDENTS.INDENT_20});
  width: 100%;
`
